import { z } from 'zod';

export const color = z
  .string()
  .regex(
    /^(#[0-9A-F]{6})?$/i,
    'Color must be a valid hex color (Example: #000000)'
  );

export const colorRequired = color.min(1, 'Color is required');

export const colorNoBlackOrWhite = colorRequired.regex(
  /^(?!#000000$|#FFFFFF$)(#[0-9A-F]{6})$/i,
  'Color must be a valid hex color and cannot be black (#000000) or white (#FFFFFF)'
);
